
import UiIcon from "@/components/UI/UiIcon.vue";
import SearchResultItem from "@/components/common/search/SearchResultItem.vue";
import SearchNoResults from "@/components/common/search/SearchNoResults.vue";

export default {
  name: "SearchResult",
  components: {
    UiIcon,
    SearchResultItem,
    SearchNoResults,
  },
  props: {
    search: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    listData: {
      type: Array,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
};
